//Helper functions
import _ from 'lodash';

function getConsultantName(consultant) {
    let name = '';
    if (!consultant) {
        return 'Not Set';
    }

    if (typeof consultant === 'string') {
        return consultant;
    }

    if (consultant.__description) {
        name = consultant.__description;
    }

    if (consultant.familyName) {
        if (consultant.firstName) {
            name = `${_.capitalize(consultant.familyName)}, ${_.capitalize(consultant.firstName)}`;
        } else {
            name = `${_.capitalize(consultant.familyName)}`;
        }
    }

    return name;
}

function getConsultantCode(consultant, defResult = '') {
    let code = '';
    if (!consultant) {
        return 'Not Set';
    }

    if (typeof consultant === 'string') {
        return defResult;
    }

    if (consultant.hasOwnProperty('__code') && consultant['__code'] != null) {
        code = consultant.__code;
    } else {
        if (consultant.hasOwnProperty('code') && consultant['code'] != null) {
            code = consultant.code;
        } else {
            if (consultant.hasOwnProperty('pasCode') && consultant['pasCode'] != null) {
                code = consultant.pasCode;
            } else {
                if (consultant.hasOwnProperty('_id') && consultant['_id'] != null) {
                    code = consultant._id;
                } else {
                    code = consultant.__id;
                }

            }
        }
    }
    return code;
}

export {getConsultantCode, getConsultantName};

export const consultantDictionary = {
    seeAndTreat: 'seeAndTreat',
    rapidAssessment: 'rapidAssessment',
    currentClinician: 'currentClinician',
    ambulanceHandover: 'ambulanceHandover',
    triage: 'triage',
    clerking: 'clerking',
    csmContactTime: 'csmContactTime',
    handover: 'handover',
    medicalPlan: 'medicalPlan',
    nursingPlan: 'nursingPlan',
    nursingChecklistQuestions: 'nursingChecklistQuestions',
    medicalChecklistQuestions: 'medicalChecklistQuestions',
    currentNurse: 'currentNurse',
    clinicalConclusion: 'clinicalConclusion',
    seniorReview: 'seniorReview',
    discharge: 'discharge',
    treatmentPlan: 'treatmentPlan',
    bedBooking: 'bedBooking',
    arrival: 'arrival',
    nurseForm: 'nurseForm',
    admitting: 'admitting',
    //book admission module
    mduEditFormAdmissionConsultant: 'mduEditFormAdmissionConsultant',
    tciEditFormOverseeingConsultant: 'tciEditFormOverseeingConsultant',
    patientListFilterOverseeingConsultant: 'patientListFilterOverseeingConsultant',
    workListFilterOverseeingConsultant: 'workListFilterOverseeingConsultant',
    sessionModalOverseeingConsultant: 'sessionModalOverseeingConsultant',
    sessionModalAnaesthetist: 'sessionModalAnaesthetist',
    sessionModalSurgeon: 'sessionModalSurgeon',
    mySessionSurgeon: 'mySessionSurgeon',
    mySessionAnaesthetist: 'mySessionAnaesthetist',
    mySessionOverseeingConsultant: 'mySessionOverseeingConsultant',
    admissionFilterOverseeingConsultant: 'admissionFilterOverseeingConsultant',
    admissionFilterSurgeon: 'admissionFilterSurgeon',
    admissionFilterAnaesthetist: 'admissionFilterAnaesthetist',
    //end book admission module
};